export default __webpack_public_path__ + "static/pricing-9fb2eda350ee9182b4ccbd5385d22cf6.png";